import { getLocalStorage } from './storageHelper';

export const CONSENT_STORAGE_KEY = 'cookie_consent';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const consentParams = (granted: boolean): Gtag.ConsentParams => {
  const value = granted ? 'granted' : 'denied';

  return {
    analytics_storage: value,
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
  };
};

const ensureGtag = () => {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // GTM/gtag only recognize consent commands pushed as an `arguments` object,
    // so this must stay a classic function.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer?.push(arguments);
    };
  }
};

// Must run before any tag script (gtm.js, gtag.js) is loaded.
export const initConsentMode = () => {
  ensureGtag();
  window.gtag(
    'consent',
    'default',
    consentParams(getLocalStorage(CONSENT_STORAGE_KEY, null) === true)
  );
};

export const updateConsent = (granted: boolean) => {
  ensureGtag();
  window.gtag('consent', 'update', consentParams(granted));
};
